module.exports = __webpack_public_path__ + "static/img/user2.5db7f71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user2.png
// module id = yWST
// module chunks = 1